/**
 * PayNowStartPage — public "Pay Now" deep-link target (/pay-now).
 * Opens the full Razorpay checkout flow (SubscriptionPaymentModal) immediately.
 * Optional query params ?name=&phone= prefill the lead. On close → home.
 */
import React, { useState } from 'react';
import { useNavigate, useSearchParams, Navigate } from 'react-router-dom';
import SubscriptionPaymentModal from '../components/SubscriptionPaymentModal';
import { useAuth } from '../App';

const LOGO = 'https://customer-assets.emergentagent.com/job_b71b88a0-de31-4e82-b047-c99df2477168/artifacts/7dlw52ts_logo%20%281%29.jpg';

export default function PayNowStartPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [open, setOpen] = useState(true);
  const { user } = useAuth();

  // Logged-in school user → send to their own school payment page (slab pricing).
  if (user && user.school_id && ['school_admin', 'incharge'].includes(user.role)) {
    return <Navigate to={`/pay/${user.school_id}`} replace />;
  }

  const prefill = {
    contactName: params.get('name') || '',
    contactPhone: params.get('phone') || '',
    studentCount: params.get('students') ? parseInt(params.get('students'), 10) : undefined,
    source: 'whatsapp_pay_now',
  };

  return (
    <div className="min-h-screen bg-[#FFFDF9] flex flex-col items-center justify-center px-4" data-testid="pay-now-start-page">
      <img src={LOGO} alt="Shiksha Mitra" className="h-16 w-16 rounded-2xl object-cover mb-4 shadow-lg" />
      <h1 className="text-2xl font-black text-slate-800 mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>शिक्षा मित्र</h1>
      <p className="text-slate-500 text-sm mb-6 text-center">Subscription चालू करने के लिए नीचे form पूरा करें।</p>
      {!open && (
        <button onClick={() => setOpen(true)} className="px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl font-bold shadow-lg" data-testid="pay-now-reopen">
          अभी भुगतान करें →
        </button>
      )}

      <SubscriptionPaymentModal
        isOpen={open}
        onClose={() => { setOpen(false); navigate('/'); }}
        language="hi"
        prefillData={prefill}
        source="whatsapp_pay_now"
      />
    </div>
  );
}
